export default {
    'navbar.home': 'Home',
    'navbar.activity': 'Activity',
    'navbar.wallt': 'Wallt',
    'navbar.acting': 'Acting',
    'navbar.mine': 'Mine'
};